import { Button } from "@sellar-io/components";
import { useState } from "react";

import { useIntegrationDelete } from "../../../hooks/api/v2/integration/useIntegrationDelete";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { IntegrationDeactivationModal } from "./IntegrationDeactivationModal";

export const IntegrationAppDelete = ({
  appName,
  setMessage,
  integrationId,
}: {
  appName: string;
  integrationId: number;
  setMessage?: (message: string) => void;
}) => {
  const deleteIntegrationMutation = useIntegrationDelete(integrationId);
  const [isActive, setIsActive] = useState(false);
  const { business: userBusiness } = useSellarCurrentBusiness();

  if (!userBusiness) throw new Error("Cannot determine business");

  const deleteIntegration = async () => {
    deleteIntegrationMutation.mutate(undefined, {
      onError: () =>
        setMessage?.(
          `There was a problem disconnecting your ${appName} account. Please contact support`,
        ),
      onSettled: () => setIsActive(false),
    });
  };

  return (
    <>
      <Button color={"inverse-red"} onClick={() => setIsActive(true)}>
        Disconnect
      </Button>

      <IntegrationDeactivationModal
        active={isActive}
        onDismiss={() => setIsActive(false)}
        loading={deleteIntegrationMutation.isPending}
        onSubmit={deleteIntegration}
        title={`Deactivate ${appName}?`}
        subtitle={`Are you sure? This will stop data from Sellar being shared with ${appName}`}
      />
    </>
  );
};
